export enum NavBarCategory {
  app = 'app',
  user = 'user',
  supplierAnalytics = 'supplierAnalytics'
}
